<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      :overlay="true"
      max-width="400"
      transition="dialog-transition"
    >
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="info" color="white"
          >Category
          <v-icon right>fas fa-sitemap</v-icon>
        </v-btn>
      </template> -->
      <v-card class="" max-width="400">
        <v-card-title>
          <v-toolbar flat :class="titleColor">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" :disabled="clicked" @click="close" icon small>
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="ExpenseForm" class="mt-2">
            <v-text-field
              outlined
              v-model.trim="ExpensName"
              :rules="[rules.required]"
              label="Account Name"
              id="ExpensNameID"
            ></v-text-field>

            <p class="font-weight-black mt-3 text-center" v-html="msgError"></p>
            <v-btn
              block
              @click="OnCreateExpense"
              :loading="clicked"
              class="elevation-6"
              rounded
              color="red darken-3"
              dark
              width="150"
              >Create</v-btn
            >
          </v-form>
          <v-card-actions> </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  // AccCharts
  props: {
    OpenNewExpense: { type: Boolean, required: true },
    AccountType: { type: Number, default: 14 },
    title: { type: String, default: "New Expense" },
    titleColor: { type: String, default: "warning darken-4 white--text" },
    loadFunction: { type: Function, required: true },
  },

  data() {
    return {
      URL: "/Account",
      dialog: false,
      msgError: "",
      clicked: false,
      ExpensName: "",
      rules: {
        required: v => {
          if (!v) return "Account Name is Required.";
          //   else if (v.length > 3) return "Only 3 Character allowed";
          return true;
        },
      },
      //   dialog: false,
    };
  },
  watch: {
    OpenNewExpense(v) {
      if (v) this.dialog = v;
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$emit("OnClosed", false);
      this.msgError = "";
    },
    OnCreateExpense() {
      this.msgError = "";
      if (this.$refs.ExpenseForm.validate()) {
        this.clicked = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.URL,
            data: {
              AccountName: this.ExpensName.toUpperCase(),
              AccountType: this.AccountType,
            },
          })
          .then(() => {
            this.clicked = false;
            this.$refs.ExpenseForm.reset();
            this.loadFunction();
            this.close();
            // console.log(result);
            // this.AllSuppliers = result.data;
          })
          .catch(err => {
            this.clicked = false;
            this.msgError = err.response.data;
            // console.log(err);
          });
      }
    },
  },
};
</script>
<style scoped>
span {
  /* border-bottom: solid double 2px black; */
  border-bottom: double black;
}
</style>
